import React from 'react'
import { Dropdown, DropdownProps as StormDropdownProps } from '@amzn/storm-ui'
import { FeedbackFormField, FeedbackFormInputProps } from '@amzn/storm-ui-feedback-form-kit'

interface DropdownProps extends Omit<StormDropdownProps, 'mobileFullScreen'> {
  defaultLabel: string
}

const DropdownForFeedbackForm = ({ name, defaultValue, disabled, id, onChange, children, defaultLabel, ...dropDownProps }: FeedbackFormInputProps<DropdownProps>) => (
  <FeedbackFormField name={name} id={id} defaultValue={defaultValue ?? ''}>
    {({ id: inputId, isSubmitting, error, onChange: internalOnChange, value: internalValue }) => {
      const errorMessage = error?.message
      const handleChange: DropdownProps['onChange'] = (value, event) => {
        internalOnChange(value)
        if (typeof onChange === 'function') {
          onChange(event)
        }
      }

      const handleOverrideLabel = (label, value) => (value ? label : defaultLabel)

      return (
        <Dropdown
          onOverrideLabel={handleOverrideLabel}
          {...dropDownProps}
          onChange={handleChange}
          selectedValue={internalValue}
          mobileFullScreen
          disabled={disabled || isSubmitting}
          id={inputId}
          error={!!errorMessage}
        >
          {children}
        </Dropdown>
      )
    }}
  </FeedbackFormField>
)

export default DropdownForFeedbackForm
